<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="grid grid-cols-12 gap-3 py-5 container">
            <div class="col-span-12 md:col-span-6 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('employee.position') }}
                </div>
                <InputBox
                    class="px-0"
                    model-name="name"
                    check-to-model="modelNotEmptyState"
                    :model-form="modelForm"
                    :errors="errors"
                    :no-margin-top="true"
                />
            </div>

            <div class="col-span-12 md:col-span-6">
                <SubmitRow
                    md-size="6"
                    v-if="canManageEmployees()"
                    :text="submitButtonName"
                    :is-disabled="hasErrors"
                    :is-loading="isLoading"
                    :do-action="add"
                />
            </div>
        </div>
    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import InputBox from "@/components/InputBox";
import accessMixin from "@/mixin/accessMixin";
import SubmitRow from "@/components/SubmitRow";
import validatorMixin from "@/mixin/validatorMixin";
import {mapActions, mapGetters} from "vuex";
import Modal from "@/components/html/Modal";

export default {
    name: "EmployeePositionAdd",
    components: {Modal, SubmitRow, InputBox, Row},
    mixins: [accessMixin, validatorMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.position', url: 'employees/positions'},
                {name: this.$route.name === 'employees/positions/show' ? 'edit' : 'add'},
            ],
            modelForm: {
                id: null,
                name: '',
            },
            errors: {
                name: null,
            },
            modalText: '',
            isLoading: false,
            submitButtonName: 'add',
        }
    },
    computed: {
        ...mapGetters(['getEmployeePosition'])
    },
    methods: {
        ...mapActions(['pushEmployeePosition', 'setBreadcrumbItems']),
        add() {
            this.isLoading = true

            this.pushEmployeePosition(this.modelForm)
                .then(() => {
                    this.isLoading = false
                    this.$i18nHelper.toUrl('employees/positions')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.params.id) {
            let position = this.getEmployeePosition(parseInt(this.$route.params.id))

            if (position) {
                this.submitButtonName = 'edit'
                this.modelForm.id = position.id
                this.modelForm.name = position.name
            }
        }
    },
}
</script>

<style scoped>

</style>